import { graphql } from "@opensea/graphql"

export const CancelOrderFlowStatus_orderFragment = graphql(`
  fragment CancelOrderFlowStatus_order on Order {
    id
    side
    type
    collection {
      imageUrl
    }
    item {
      imageUrl
    }
  }
`)
